@if (flags.sidenav) {
  <div class="sidenav-backdrop animate__animated animate__fadeIn" (click)="closeSidenav()"></div>
}

<div [class.ios]="utils.ios()" [class.android]="utils.android()" class="sidenav" [class.open]="flags.sidenav" (swipeleft)="closeSidenav()">

  <button mat-button type="button" class="top-close-btn" (click)="closeSidenav();utils.sound()" [class.ios]="utils.ios()" [class.android]="utils.android()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
  @if (!user?.isAuthenticated) {
    <h1>options</h1>
    <a mat-button (click)="clickLogin();utils.sound('yes')">Join <mat-icon>chevron_right</mat-icon></a>
    <a mat-button (click)="clickLogin();utils.sound('click-face')">Login <mat-icon>chevron_right</mat-icon></a>
    <a routerLink="/about" mat-button (click)="closeSidenav();utils.sound()">Start <mat-icon>play_circle_outline</mat-icon></a>
    <a mat-button (click)="closeSidenav();utils.sound();openExternal('https://www.activity8.com')">Website<mat-icon>web</mat-icon></a>
    <a mat-button (click)="closeSidenav();utils.sound();openExternal('https://www.activity8.com/contact')">Contact <mat-icon>campaign</mat-icon></a>
    <br />
    <div class="download">
      <mat-icon>face</mat-icon>
      <h2>hello gorgeous</h2>
    </div>
  }

  @if (user && user.isAuthenticated) {
    <h1 (click)="closeSidenav();utils.sound('click-face')">
      @if (user?.first_name != '') {
        <span>{{ user?.first_name }}</span>
      }
      @if (user?.first_name == '') {
        <span>ur name?</span>
      }
    </h1>
    <div class="username" routerLink="/{{user?.username}}" (click)="closeSidenav();utils.sound('click-face')">&#64;{{user?.username}}</div>
    <div class="profile">
      <div class="border" [style.border-color]="user.color">
        @if (getProfileBackground(user) == 'none') {
          <div class="noImage" routerLink="/{{user?.username}}" (click)="closeSidenav();utils.sound('click-face')" [style.border-color]="user?.color"  [style.color]="user?.color + '80'">
            @if (user?.first_name!='') {
              <span>{{user?.first_name}}</span>
            }
            @if (user?.first_name=='') {
              <span>:(</span>
            }
          </div>
        }
        <button routerLink="/{{user?.username}}" (click)="closeSidenav();utils.sound('click-face')" [style.background-image]="flags.userImg">
          @if (user?.is_premium && !user?.is_verified) {
            <mat-icon matTooltip="Premium Member" class="premium" [style.color]="user?.color">star</mat-icon>
          }
          @if (!user?.is_premium && user?.is_verified) {
            <mat-icon matTooltip="Verified Member" class="premium" [style.color]="user?.color">fingerprint</mat-icon>
          }
          @if (user?.is_premium && user?.is_verified) {
            <mat-icon matTooltip="Verified & Premium" class="premium" [style.color]="user?.color">verified</mat-icon>
          }
          @if (user?.meta?.is_new && !user?.is_verified && !user?.is_premium) {
            <mat-icon class="premium" [style.color]="user?.color">fiber_new</mat-icon>
          }
          <!-- <div class="counter" [class.lightMode]="user?.color|isLight" [style.background-color]="user?.color">{{user?.activities?.length}}</div> -->
        </button>
      </div>
    </div>
    <div class="balance">
      <p [style.color]="user.color">Earned</p>
      <h2><button mat-button routerLink="/settings/transactions" (click)="closeSidenav();utils.sound()">{{balanceText}}</button></h2>
      @if (balance == 0 && user.referral_code != null) {
        <a (click)="openExternal('https://www.activity8.com/journal/earn')">learn to earn</a>
      }
      @if (user.referral_code == null && balance == 0) {
        <a routerLink="/settings/transactions" (click)="closeSidenav();utils.sound()">set referral link to earn</a>
      }
      @if (balance != 0) {
        <a (click)="claim()">{{ flags.claimLoading ? 'processing...' : 'claim your earnings now' }}</a>
      }
      @if (utils.ios()) {
        <button class="walletBadgeBtn" (click)="addToWallet()" [disabled]="flags.walletLoading" aria-label="Add to Apple Wallet">
          @if (flags.walletLoading) {
            <span class="walletLoadingText">Adding…</span>
          } @else {
            <img src="./assets/img/add-to-apple-wallet.png" alt="Add to Apple Wallet" />
          }
        </button>
      }
    </div>
    @if (user?.hasPerm('admin.add_logentry')) {
      <a routerLink="/admin" mat-button (click)="closeSidenav();utils.sound()">Admin <mat-icon>admin_panel_settings</mat-icon></a>
    }
    <a routerLink="/{{user.username}}" mat-button (click)="closeSidenav(); utils.sound('click-face')">Profile <mat-icon>face</mat-icon></a>
    <a routerLink="/settings" mat-button (click)="closeSidenav();utils.sound()">Settings <mat-icon>settings</mat-icon></a>
    <a mat-button (click)="closeSidenav();utils.sound();openExternal('https://www.activity8.com/help')">How to... <mat-icon>help</mat-icon></a>
    <a mat-button (click)="closeSidenav();utils.sound();openExternal('https://www.activity8.com/giveaway')">Giveaways <mat-icon>volunteer_activism</mat-icon></a>
    <a routerLink="/contact" mat-button (click)="closeSidenav();utils.sound()">Feedback <mat-icon>campaign</mat-icon></a>
    <a routerLink="/logout" mat-button (click)="closeSidenav();utils.sound()">Logout <mat-icon>logout</mat-icon></a>
  }


  <div class="footer">
    <a routerLink="/privacy" (click)="closeSidenav();utils.sound()">Privacy Policy</a>
    <a routerLink="/terms" (click)="closeSidenav();utils.sound()">Terms of Service</a><br />
    &copy; copyright activity8 {{ today|date:'yyyy' }}
  </div>
</div>
